<template lang="pug">
.register-row.form-label
  .register-group
    .register-key
      span.key-name 施設での食事の表示項目
      span.validation-label 必須
      slot(name="question")
    .register-value
      InputUseNeedsMealTable(v-model="_items" :fields="fields")
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

import { NeedsMeal } from "@/commons/services/Outings";
import InputUseNeedsMealTable, { InputUseNeedsMealTableItem, InputUseNeedsMealTableField } from "@/pc/components/outings/InputUseNeedsMealTable.vue";

/**
 * ### 施設での食事の使用有無 入力コンポーネント
 */
@Component({
  components: {
    InputUseNeedsMealTable
  }
})
export default class InputUseNeedsMeal extends Vue {
  /** 施設での食事の使用有無 */
  @Prop({ required: true })
  value!: NeedsMeal;

  /** 列名配列 */
  fields: Array<InputUseNeedsMealTableField> = [];

  get _items(): Array<InputUseNeedsMealTableItem> {
    if (!this.value) {
      return [];
    }
    return [{ needsMeal: this.value }];
  }

  /**
   * ### vue lifecycle mounted
   */
  public async mounted(): Promise<void> {
    const fields: Array<InputUseNeedsMealTableField> = this.createFields();
    this.fields = fields;
    return;
  }

  /**
   * ### テーブル列名を作成する
   */
  public createFields(): Array<InputUseNeedsMealTableField> {
    const fields: Array<InputUseNeedsMealTableField> = [];
    fields.push({ key: "breakfast", label: "朝食", sortable: false, sortDirection: "desc", class: "meal-name breakfast text-center" });
    fields.push({ key: "lunch", label: "昼食", sortable: false, sortDirection: "desc", class: "meal-name lunch text-center" });
    fields.push({ key: "snack", label: "おやつ", sortable: false, sortDirection: "desc", class: "meal-name snack text-center" });
    fields.push({ key: "dinner", label: "夕食", sortable: false, sortDirection: "desc", class: "meal-name dinner text-center" });
    return fields;
  }
}
</script>
